import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import { graphql, compose } from "lib/apolloClient";
import classes from "./User.scss";
import { getUserFeedQuery } from "Tooling/modules/ToolingQueries";
import { getUserFeedFromCache } from "Tooling/modules/ToolingGraphqlHelpers";
import withLoader from "UIComponents/GqlWithLoader";
import I18nHOC from "UIComponents/I18nHOC";
import Loading from "UIComponents/Loading";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import Header from "./components/Header";
import FilterHeader from "./components/FilterHeader";
import FeedList from "AppComponents/FeedList";
import { goToBack } from "modules/NavigationModule";
import {
  changeUserSearchString,
  updateFilters,
  changeSearchTerm,
} from "Tooling/modules/ToolingModule";
import { REGION_FILTER_OPTIONS } from "Platform/routes/Regions/modules/Module";
import { setPortalType } from "Login/modules/LoginModule";

//DS
import { SearchInput } from "@toddle-edu/ds-web";

import { checkScrollAtBottom } from "Utils";

const UserList = compose(withLoader)(FeedList);
const parentStyle = {
  gridTemplateColumns: "15% 18% 18% 21% 20%",
  gridColumnGap: "20px",
};
const columnDataStyle = {
  wordBreak: "break-all",
};
const columnList = () => [
  {
    label: "System ID",
    id: "id",
    type: "TEXTCOLUMN",
  },
  {
    label: "User Name",
    id: "name",
    type: "NAMEWITHIMAGE",
  },
  {
    label: "Designation",
    id: "designation",
    type: "TEXTCOLUMN",
  },
  {
    label: "Email ID",
    id: "email",
    type: "TEXTCOLUMN",
    columnDataStyle,
  },
  {
    label: "Organization",
    id: "organization",
    type: "TEXTCOLUMN",
    columnDataStyle,
  },
];

class User extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
      isLoading: false,
      teacherModal: false,
    };
  }

  componentWillUnmount() {
    this.props.updateFilters({
      regionIds: REGION_FILTER_OPTIONS.map(region => region.value),
      organizations: [],
    });
    this.changeSearchTerm("");
  }

  changeSearchTerm = value => {
    this.props.changeUserSearchString({ users: value });
  };

  getFeed = () => {
    const { users } = this.props;
    return _.map(users, user => {
      const {
        id,
        firstName,
        lastName,
        profileImage,
        designation,
        email,
        role,
        organization,
      } = _.get(user, "node", {}) || {};
      return {
        id: id,
        name: {
          name: firstName + " " + lastName,
          profileImage: profileImage,
        },
        designation: _.get(designation, "title") || role,
        email,
        organization: _.get(organization, "name", ""),
      };
    });
  };

  onScroll = e => {
    const { hasNextPage, networkStatus, loadMoreResult } = this.props;
    const containerDiv = e.target;

    if (
      containerDiv &&
      hasNextPage &&
      networkStatus != 3 &&
      checkScrollAtBottom(containerDiv)
    ) {
      loadMoreResult();
    }
  };

  render() {
    const {
      isData,
      isLoading,
      totalCount,
      networkStatus,
      updateFilters,
      filters,
    } = this.props;
    const { isLoading: isStateLoading } = this.state;
    return (
      <div className={classes.container} onScroll={e => this.onScroll(e)}>
        <div className={classes.innerContainer}>
          <Header goToBack={this.props.goToBack}></Header>
          <div className={classes.header}>
            <div className={classes.innerHeader}>
              <div className={classes.leftHeader}>
                <SearchInput
                  size={"medium"}
                  placeholder={`Search by User name or Email ID`}
                  onChange={this.changeSearchTerm}
                  value={this.props.searchText}
                />
              </div>
              <div className={classes.rightHeader}>{`${totalCount} Users`}</div>
            </div>

            <FilterHeader filters={filters} updateFilters={updateFilters} />
          </div>

          <UserList
            parentStyle={parentStyle}
            columnList={columnList()}
            feedData={this.getFeed()}
            fetchMoreFeed={this.fetchMoreFeed}
            isData={isData}
            isLoading={isLoading}
          />
        </div>
        {networkStatus == 3 && (
          <div className={classes.loadingContainer}>
            <Loading />
          </div>
        )}
        {isStateLoading && <FullScreenLoader></FullScreenLoader>}
      </div>
    );
  }
}

const mapActionCreators = {
  goToBack,
  changeUserSearchString,
  changeSearchTerm,
  updateFilters,
  setPortalType,
};

const mapStateToProps = (state, ownProps) => {
  const searchText = _.get(state, "tooling.searchString.users", "");
  const filters = _.get(state, "tooling.filters", {});
  const { organizations, regionIds } = filters;

  const variables = {
    organizations,
    regionIds,
    searchText,
  };

  return {
    isData: true,
    isLoading: false,
    searchText,
    filters,
    variables,
  };
};

export default compose(
  I18nHOC({ resource: ["toastMsgs"] }),
  connect(mapStateToProps, mapActionCreators),
  graphql(getUserFeedQuery, {
    name: "getUserFeed",
    options: ({ variables }) => ({
      fetchPolicy: "cache-and-network",
      variables,
    }),
    props({ getUserFeed, ownProps: { isData, isLoading, variables } }) {
      const userDetails = getUserFeedFromCache(variables);

      const users = _.get(userDetails, "edges", []);
      const totalCount = _.get(userDetails, "totalCount", 0);
      return {
        totalCount,
        users,
        getUserFeed,
        hasNextPage: _.get(userDetails, "pageInfo.hasNextPage", false),
        networkStatus: getUserFeed["networkStatus"],
        isData: !_.isEmpty(userDetails) && isData,
        isLoading:
          getUserFeed["networkStatus"] == 1 ||
          getUserFeed["networkStatus"] == 2 ||
          isLoading,
        loadMoreResult: () => {
          return getUserFeed.fetchMore({
            variables: {
              after: userDetails.pageInfo.endCursor,
              ...variables,
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
              const previousFeed = previousResult.platform.userFeed;
              const nextFeed = fetchMoreResult.platform.userFeed;

              const previousEdges = previousFeed.edges;
              const nextEdges = nextFeed.edges;

              const previousPageInfo = previousFeed.pageInfo;
              const nextPageInfo = nextFeed.pageInfo;

              const nextEndCursor = nextPageInfo.endCursor;
              const nextHasNextPage = nextPageInfo.hasNextPage;
              return {
                ...previousResult,
                platform: {
                  ...previousResult.platform,
                  userFeed: {
                    ...previousResult.platform.userFeed,
                    edges: [...previousEdges, ...nextEdges],
                    pageInfo: {
                      ...previousPageInfo,
                      endCursor: nextEndCursor,
                      hasNextPage: nextHasNextPage,
                    },
                  },
                },
              };
            },
          });
        },
      };
    },
  })
)(User);
